export default {
    SAVE: (state, payload) => {
        const { type, data=undefined, dataTotal } = payload
        state[`${type}`] = data
        state[`${type}Total`] = dataTotal;
    },
    FailSave: (state, payload) => {
        const { type, data={} } = payload
        // console.log('11', `${type}Total`)
        state[`${type}Total`] = data
    },
}